import {TagProfile} from "@/models/Profiles/TagProfile.model";
import ApiService from "@/services/api.service";

class ProfileService extends ApiService {
    constructor() {
        super();
    }

    public async getAvailableProfiles(): Promise<TagProfile[]> {
        const url = "/api/Profile";
        const response = await this.axiosInstance.get<TagProfile[]>(url);
        return (response.data || []).map((item) => new TagProfile(item));
    }
    public async changeProfile(deviceId: string, profileId: string ): Promise<boolean> {
        const url = `/api/Profile/${profileId}/device/${deviceId}`;
        const response = await this.axiosInstance.post<boolean>(url);
        return response.data;
    }
}
export default new ProfileService();
